import { Formik } from "formik";
import { AnalisisLaboratorioSchema } from "../data/AnalisisLaboratorioSchema";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Button from "./controls/Button";
import TextField from "./controls/TextField";
import { isInvalid } from "../utils/forms";
import DateTimeField from "./controls/DateTimeField";
import SelectField from "./controls/SelectField";
import AmmountField from "./controls/AmmountField";
import ArrayField from "./controls/ArrayField";
import { useTranslation } from "react-i18next";
import { crearMedicion } from "../utils/data";
import { MedicionForm } from "./MedicionForm";
import { TipoMuestra } from "../utils/enums";

export function AnalisisLaboratorioForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  disabled,
  tiposMuestreo,
  unidadPeriodoMuestreo,
  unidadCaudalMedio,
  contaminantes,
}) {
  const { t } = useTranslation();
  const handleProtocoloChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleFechaChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handlePeriodoMuestreoChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleLaboratorioChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleTipoMuestraChange = (form) => (event) => {
    const tipo = event.target.value;
    if (tipo.codigo === TipoMuestra.PUNTUAL) {
      form.setFieldValue("periodoMuestreo", null, false);
    }
    form.handleChange(event);
  };
  const handleCaudalMedioChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleResultadosChange = (form) => (event) => {
    form.handleChange(event);
  };
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={AnalisisLaboratorioSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(form) => (
        <Grid style={{ marginLeft: "4px", marginRight: "8px" }}>
          <Row>
            <Col lg={6}>
              <TextField
                id="analisisLaboratorio_protocolo"
                name="protocolo"
                label={t("analisisLaboratorio.protocolo")}
                value={form.values.protocolo}
                onChange={handleProtocoloChange(form)}
                isInvalid={isInvalid("protocolo", form)}
                error={t(form.errors.protocolo)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <DateTimeField
                id="analisisLaboratorio_fecha"
                name="fecha"
                label={t("analisisLaboratorio.fecha")}
                value={form.values.fecha}
                onChange={handleFechaChange(form)}
                isInvalid={isInvalid("fecha", form)}
                error={t(form.errors.fecha)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <TextField
                id="analisisLaboratorio_laboratorio"
                name="laboratorio"
                label={t("analisisLaboratorio.laboratorio")}
                value={form.values.laboratorio}
                onChange={handleLaboratorioChange(form)}
                isInvalid={isInvalid("laboratorio", form)}
                error={t(form.errors.laboratorio)}
                disabled={disabled}
              />
            </Col>
            <Col lg={4}>
              <SelectField
                id="analisisLaboratorio_tipoMuestra"
                name="tipoMuestra"
                label={t("analisisLaboratorio.tipoMuestra")}
                value={form.values.tipoMuestra}
                onChange={handleTipoMuestraChange(form)}
                options={tiposMuestreo}
                labelAttr="nombre"
                valueAttr="codigo"
                emptyLabel="..."
                isInvalid={isInvalid("tipoMuestra", form)}
                error={t(form.errors.tipoMuestra)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="analisisLaboratorio_periodoMuestreo"
                name="periodoMuestreo"
                label={t("analisisLaboratorio.periodoMuestreo")}
                value={form.values.periodoMuestreo}
                onChange={handlePeriodoMuestreoChange(form)}
                unit={unidadPeriodoMuestreo}
                isInvalid={isInvalid("periodoMuestreo", form)}
                error={t(form.errors.periodoMuestreo)}
                disabled={
                  disabled ||
                  form.values?.tipoMuestra?.codigo === TipoMuestra.PUNTUAL
                }
              />
            </Col>
            <Col lg={4}>
              <AmmountField
                id="analisisLaboratorio_caudalMedio"
                name="caudalMedio"
                label={t("analisisLaboratorio.caudalMedio")}
                value={form.values.caudalMedio}
                onChange={handleCaudalMedioChange(form)}
                unit={unidadCaudalMedio}
                isInvalid={isInvalid("caudalMedio", form)}
                error={t(form.errors.caudalMedio)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <ArrayField
                id="analisisLaboratorio_resultados"
                name="resultados"
                label={t("analisisLaboratorio.resultados")}
                value={form.values.resultados}
                onChange={handleResultadosChange(form)}
                isInvalid={isInvalid("resultados", form)}
                createItem={crearMedicion}
                error={t(form.errors.resultados)}
                disabled={disabled}
              >
                {({ value, append, remove, disabled }) => (
                  <MedicionForm
                    value={value}
                    append={append}
                    remove={remove}
                    contaminantes={contaminantes || []}
                    disabled={disabled}
                  />
                )}
              </ArrayField>
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("analisisLaboratorioForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("analisisLaboratorioForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    form.submitForm();
                  }}
                  disabled={disabled}
                />
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
